module.exports = __webpack_public_path__ + "img/fea_tech.a363671f.png";